import { CourierType } from 'components/agencyView/AgencyView';

export interface CourierTypeTabsProps {
  activeTabs: CourierType;
  onTabClick: (key: string) => void;
}

const CourierTypeTabs = ({ activeTabs, onTabClick }: CourierTypeTabsProps) => {
  const displayNames: { [key: string]: string } = {
    1: 'Active Couriers',
    2: 'Inactive Couriers',
    3: 'All couriers',
  };

  return (
    <div className="my-3">
      <ul className="flex gap-2 border-b border-muted-white">
        {Object.entries(displayNames).map(([key, value]) => (
          <button type="button" onClick={() => onTabClick(key)} key={key}>
            <li
              className={`p-2 ${
                activeTabs.toString() === key && 'border-b font-semibold'
              }`}
            >
              {value}
            </li>
          </button>
        ))}
      </ul>
    </div>
  );
};

export default CourierTypeTabs;
